import React, { useState } from 'react'
import { NotificationsBadge } from './NotificationsBadge'
import { NotificationsDialog } from './NotificationsDialog'
import { useAuth0 } from '../../Hooks/auth0'
import { useQuery, useMutation } from '@apollo/client'
import { gql } from '@apollo/client'

const QUERY = gql`
  query notificationsQuery ($userId: String!) {
    notifications(userId: $userId) {
        id
        notified_user_id
        notification_text
        action_url
        created_date
        is_read
    }
  }
`

const MUTATION = gql`
mutation updateNotificationIsRead($notificationId: ID!) {
    updateNotificationIsRead(notificationId: $notificationId) 
}
`

export default () => {
    const { user, logout } = useAuth0()
    const [notificationsDialogIsOpen, setNotificationsDialogIsOpen] = useState(false)
    const [notifications, setNotifications] = useState([])

    if (!user) {
        logout()
    }

    const { loading, error, data, refetch } = useQuery(QUERY, {
        notifyOnNetworkStatusChange: true,
        variables: {
            userId: user.id
        },
        pollInterval: 600000, //10 minute polling
    })

    const [updateNotificationIsRead] = useMutation(MUTATION)

    const markNotificationRead = async (id) => {
        await updateNotificationIsRead({
            variables: {
                notificationId: id,
            }
        })
        refetch()
    }

    return (
        <div>
            {notificationsDialogIsOpen &&
                <NotificationsDialog
                    allNotifications={notifications}
                    markNotificationRead={markNotificationRead}
                    notificationsDialogIsOpen={notificationsDialogIsOpen}
                    setNotificationsDialogIsOpen={setNotificationsDialogIsOpen}
                />}
            <NotificationsBadge
                data={data}
                error={error}
                loading={loading}
                setNotifications={setNotifications}
                setNotificationsDialogIsOpen={setNotificationsDialogIsOpen}
            />
        </div>
    )
}